import React from 'react';
import Timeline from '../../../react4xp/components/Timeline'

function TimelinePart({items}) {
	return <Timeline
		timeline={items?.map(item => ({
			image: item.image?.link && {
				src: item.image.link,
				alt: item.image.alt
			},
			year: item.year,
			title: item.title,
			text: item.text && `<p>${item.text}</p>`,
			milestones: item.milestones?.length ? item.milestones : undefined
		}))}
	/>
}

export default (props) => <TimelinePart {...props} />
